import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Some shells (dashboard, admin, portal) scroll an inner <main> instead of the window.
    document.querySelector("main")?.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}
